<h3 class="heading-center">{{languageData['Bestelloptionen']['VarPreisrechnerBestelloptionen4']|| "Ein technischer Fehler ist aufgetreten" }}</h3>
<p class="prewrap"> {{languageData['Bestelloptionen']['VarPreisrechnerBestelloptionen5']}}</p>
<button class="au-btn btn-default"  (click)="onclick()"
      style="margin-top:5px">Schließen</button>